import { ReactElement } from 'react';
import { EPageTypes } from 'interfaces/sportsbook';
import {
  ESportsbookPageTypes,
  TSportsbookConfigs
} from 'interfaces/sportsbook-configs';
import { SportsbookLeftSideBar } from 'elements/SportsbookLeftSideBar';
import { FavoriteSideBarSearchSection } from 'elements/SportsbookLeftSideBar/FavoriteSideBarSearchSection';
import { SportsbookGameListWrapper } from 'newcomponents/Shared/sportsbook/SportsbookGameListWrapper';

type TFirstColumnContentProps = {
  isLive: boolean;
  configs: TSportsbookConfigs;
};

export const FirstColumnContent = ({
  isLive,
  configs
}: TFirstColumnContentProps): ReactElement => {
  if (isLive) {
    return (
      <>
        <FavoriteSideBarSearchSection
          showFavoriteTeam={
            !!configs.favoriteTeam &&
            configs.pageType === ESportsbookPageTypes.prematch
          }
        />
        <SportsbookGameListWrapper
          pageType={isLive ? EPageTypes.live : EPageTypes.prematch}
        />
      </>
    );
  }

  return (
    <SportsbookLeftSideBar
      key={configs.pageType}
      configs={{
        pageType: configs.type,
        easyAccessAvailable: configs.category === 'esport',
        sportType: configs.sportType,
        favoriteTeam: configs.favoriteTeam
      }}
    />
  );
};
